<template>
  <div class="rc-rich-box-design">
    <label class="item-name">{{initComponent.name}}</label>
    <div class="editor-design" ref="editorDesign"></div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
import Editor from 'wangeditor'
export default {
  name: 'rc-rich-box',
  props: ['initComponent'],
  mixins: [componentMixin, heightMixin],
  data () {
    return {
      component: this.initComponent,
      editorContent: ''
    }
  },
  mounted () {
    let editor = new Editor(this.$refs.editorDesign)
    editor.customConfig.zIndex = 100
    editor.customConfig.showLinkImg = false
    // 设计页先用base64
    editor.customConfig.uploadImgShowBase64 = true
    editor.create()
    editor.$textElem.attr('contenteditable', false)
    this.initHeight(this.$refs.editorDesign.children[1])
  },
  watch: {
    'initComponent.properties.height' (val) {
      this.initHeight(this.$refs.editorDesign.children[1])
    }
  }
}
</script>

<style lang="scss">
.rc-rich-box-design {
  height: 100%;
  .item-name {
    float: none!important;
  }
  .editor-design {
    height: calc(100% - 25px);
    margin-top: 8px;
    .w-e-toolbar {
      display: block;
      background: #fff !important;
      border:1px solid #f1f1f1 !important;
      padding: 0;
      .w-e-menu {
        display: inline-block;
      }
    }
    .w-e-text-container {
      border:1px solid #f1f1f1 !important;
    }
    .w-e-text {
      background: #fff;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/components/rich-box/rc-rich-box.vue